// One churn/passive-signal row (docs/phase-0/slice6-component-designs.md §4.2
// `ChurnSignalCard`; UX §4.3). The SIXTH reuse of the `.control-row` rhythm
// (component-designs.md §1's reuse table). Renders the signal's own plain-language
// `summary` plus an honest "Routed to your crew" confirmation chip - a PLAIN `.chip`,
// never `.status-chip` (this is a confirmation, not a severity signal, component-
// designs.md §4.2). No deep link: no shift/intake UI screen exists in this build
// (verified: no match under apps/web/src/screens for shift/intake) - the chip is
// informational only (UX §4.3).
//
// STRUCTURALLY UNFED IN THIS BUILD: see `../api/pulse.ts`'s header comment - no landed
// wire exposes `AnomalySignal[]`/`ChurnSignalKind` back to the client, only the seven
// metrics themselves. This component is built and directly unit-tested ready for that
// read-back route to land; `PulseTab.tsx` never currently renders it with live data.
import type { AnomalySignal } from "@nightcrew/shared";
import { pulseCopy } from "../copy/pulse.js";

export const PulseChurnSignalCard = ({
  signal,
}: {
  readonly signal: AnomalySignal;
}): React.JSX.Element => (
  <div className="control-row">
    <p style={{ margin: 0 }}>{signal.summary}</p>
    <span className="chip">{pulseCopy("pulse.churnSignals.routedChip")}</span>
  </div>
);
